
import { areaDataReducer } from "../reducer/AreaDataReducer";

export const reducer = areaDataReducer;